const { default: axios } = require('axios');

const getRegionCode = async () => {
  const { data } = await axios({
    method: 'GET',
    url: '/api/geo/location',
  });

  window.geo = data

  return data.country_code !== 'US' || !data.region_code ? 'AL' : data.region_code;
};

export default getRegionCode;
